import { EXAMPLE_CASES } from '../../lib/exampleCards';
import { useSampleLoader } from './useSampleLoader';
import type { AppState } from '../../hooks/useAppState';

interface Props {
  app: AppState;
}

/** Inline hint above the image slots: small thumbnail-chip row that
 *  invites a first-time visitor to try a finished sample. Caller decides
 *  when to render — production wiring hides it once any slot is filled. */
export function ExampleInlineHint({ app }: Props) {
  const { loadingId, load } = useSampleLoader(app);

  return (
    <div className="ex-inline-row">
      <span className="ex-inline-prompt">New here? Try a finished sample:</span>
      <div className="ex-inline-chips">
        {EXAMPLE_CASES.map((c) => (
          <button
            key={c.id}
            type="button"
            className="ex-inline-chip"
            onClick={() => load(c)}
            disabled={loadingId !== null}
            title={c.blurb}
          >
            <img src={c.thumb} alt="" className="ex-inline-thumb" />
            <span className="ex-inline-chip-text">
              {loadingId === c.id ? 'Loading…' : c.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
